// Country-level access control.
//
// allowedCountries comes from Firestore ('countries' field on the
// user_permissions/{email} or omni_growth_users/{email} doc) and is
// lowercased by AuthContext. null or empty → access to all markets.
// Values may be country codes ('th') or names ('Thailand').
const COUNTRY_NAMES = {
  uk:  'united kingdom',
  us:  'united states',
  th:  'thailand',
  ksa: 'saudi arabia',
};

export function isCountryAllowed(allowedCountries, code) {
  if (!allowedCountries || allowedCountries.length === 0) return true;
  const c = (code || '').toLowerCase();
  return allowedCountries.includes(c) || allowedCountries.includes(COUNTRY_NAMES[c] || '');
}
